import styled from "styled-components";

const Wrapper = styled.main`
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default Wrapper;
